import React, {useState} from 'react'
import Card from 'react-bootstrap/Card'
import {Tile} from 'Components/Tile/Tile'
import defaultAvi from 'Static/default-avi.png';
import s from './Tile.module.scss'
import {majors} from 'Utils/majors'
import verifiedLogo from 'Static/verified_badge.png'
import backgroundImg from 'Static/backgroundImg.png'
import ReactTooltip from "react-tooltip";
import {IoMdSchool} from 'react-icons/io'
import {FaArrowRight} from "react-icons/fa";

export const DiscoverBlogCard = ({blog}) => {
  const [loading, setLoading] = useState(true)

  return <Card onClick={() => {
    if (blog?.uri) {
      window.location.href = `${window.location.href.split('/')[0]}/blog/posts/${blog.uri}`;
    }
  }} className={`medCard my-4 me-4 ${s.blogTile}`}>

    <div className={s.mentorCardAvatarContainer}>
      {blog?.coverUrl ?
          <Card.Img style={{height: '100px', objectFit: 'cover'}} variant="top"
                    src={blog?.coverUrl} onLoad={() => setLoading(false)}/> :
          <>
            <div style={{height: '100px', objectFit: 'cover'}} className={`${s.shimmerBg} ${s.imagePlaceholder}`}/>
          </>
      }

      {loading && <div style={{zIndex: 0}} className={`${s.shimmerBg} ${s.imagePlaceholder}`}/>}
    </div>

    <Card.Body>
      <Card.Title className={`${s.blogTileTitle} fs-16`}>
        {blog?.title || <div className={`${s.blogTitlePlaceholder} ${s.shimmerBg}`}></div>}
      </Card.Title>
      <Card.Text className='text-muted trunc fs-13'>
        {blog ?
            <>
              {blog?.byline || 'Anonymous'} | {blog?.university || 'Unknown University'}
            </> :
            <>
              <div className={`${s.blogDetailsPlaceholder} ${s.shimmerBg}`}></div>
            </>
        }

      </Card.Text>
    </Card.Body>
  </Card>
}

export const CollegeCard = ({college, className, key}) => {
  const [loading, setLoading] = useState(true)

  function handleRedirect() {
    const params = new URLSearchParams({
      name: college.collegeName,
      id: college.ipedsid
    })
    window.location.href = '/university?' + params
  }

  return <Card onClick={handleRedirect} className={`medCard mx-2 ${s.collegeCard} ${className}`} key={key}>
    <div className={s.mentorCardAvatarContainer}>
      {college ?
          <Card.Img style={{height: '100px', objectFit: 'cover'}} variant="top"
                    src={college?.coverUrl || backgroundImg} onLoad={() => setLoading(false)}/> :
          <>
            <div style={{height: '100px', objectFit: 'cover'}} className={`${s.shimmerBg} ${s.imagePlaceholder}`}/>
          </>
      }

      {loading && <div style={{zIndex: 0}} className={`${s.shimmerBg} ${s.imagePlaceholder}`}/>}
    </div>

    <Card.Body>
      <Card.Title className={`${s.collegeCardTitle} fs-16`}>
        {college?.collegeName || <div className={`${s.blogTitlePlaceholder} ${s.shimmerBg}`}></div>}
      </Card.Title>
      <Card.Text className={'text-muted fs-13 mt-3'}>
        {college ?
            <>
              {college.mentorCount > 0 ?
                  <>
                    <strong>{college.mentorCount || '-'} {college.mentorCount === 1 ? 'mentor' : 'mentors'}</strong> • {college.totalEnrollment || '-'} students
                  </> :
                  <>
                    <strong>{college.totalEnrollment || '-'} students</strong>
                  </>
              }
            </> :
            <>
              <div className={`${s.blogDetailsPlaceholder} ${s.shimmerBg}`}></div>
            </>
        }
      </Card.Text>
    </Card.Body>
  </Card>
};

export const HowThisWorksCard = ({information, index}) => {
  const [loading, setLoading] = useState(true)

  return <div className={`mx-4`}>
    <div className={s.howThisWorksCardBody}>
      <div className={s.howThisWorksCardBodyContents}>
        <div className={s.howThisWorksCardIndex}>
          {(index ?? 0) + 1}/3
        </div>
        <div className={s.howThisWorksCardBodyText}>
          <h1 className={s.howThisWorksHeader}>{information?.header ?? ''}</h1>
          <p className={s.howThisWorksDetails}>
            {information?.details ??
                'Showcase diversity and scale personalization by embedding ambassador-generated content and profiles across your lead generation channels.'
            }
          </p>
          <button className={s.howThisWorksLink} onClick={() => {
            window.location.href = information?.linkHref ?? '/register'
          }}>
            {information?.linkText ?? 'Get started'} <FaArrowRight/>
          </button>
        </div>
      </div>

      <div className={s.howThisWorksCardImageContainer}>
        {information ?
            <img
                className={s.howThisWorksCardImage}
                src={information?.coverUrl || backgroundImg}
                onLoad={() => setLoading(false)}
                alt=""/> :
            <>
              <div className={`${s.howThisWorksCardImage} ${s.shimmerBg} ${s.imagePlaceholder}`}/>
            </>
        }
        {loading && <div style={{zIndex: 0}} className={`${s.shimmerBg} ${s.imagePlaceholder}`}/>}
      </div>

    </div>
  </div>
};

export const LargeCollegeCard = ({college, className, key}) => {
  const [loading, setLoading] = useState(true)

  function handleRedirect() {
    if (!!college?.collegeName && !!college?.ipedsid) {
      const params = new URLSearchParams({
        name: college.collegeName,
        id: college.ipedsid
      })
      window.location.href = '/university?' + params
    }
  }

  return <Card onClick={handleRedirect} className={`mx-2 ${s.largeCollegeCard} ${className}`} key={key}>
    <div className={s.mentorCardAvatarContainer}>
      {college ?
          <Card.Img className={s.largeCollegeCardImg} variant="top"
                    src={college?.coverUrl || backgroundImg} onLoad={() => setLoading(false)}/> :
          <>
            <div className={`${s.largeCollegeCardImg} ${s.shimmerBg} ${s.imagePlaceholder}`}/>
          </>
      }

      {loading && <div style={{zIndex: 0}} className={`${s.shimmerBg} ${s.imagePlaceholder}`}/>}
    </div>

    <Card.Body>
      <Card.Title className={`${s.largeCollegeCardTitle}`}>
        {college?.collegeName || <div className={`${s.blogTitlePlaceholder} ${s.shimmerBg}`}></div>}
      </Card.Title>
      <Card.Text className={'text-muted fs-18 mt-3'}>
        {college ?
            <>
              {college.mentorCount > 0 ?
                  <>
                    <strong>{college.mentorCount || '-'} {college.mentorCount === 1 ? 'mentor' : 'mentors'}</strong> • {college.totalEnrollment || '-'} students
                  </> :
                  <>
                    <strong>{college.totalEnrollment || '-'} students</strong>
                  </>
              }
            </> :
            <>
              <div className={`${s.blogDetailsPlaceholder} ${s.shimmerBg}`}></div>
            </>
        }
      </Card.Text>
    </Card.Body>
  </Card>
};

export const MentorCard = ({mentor, connection = null, ...props}) => {
  const [loading, setLoading] = useState(true)

  return <Card onClick={props.onClick} className={`smCard ${s.mentorCard} ${props.className}`}>
    <Card.Body>
      <div className={s.mentorCardAvatarContainer}>
        {mentor ?
            <img className={s.mentorCardAvatar} style={{cursor: 'pointer', zIndex: 0}} src={mentor.photo || defaultAvi}
                 alt='avi'
                 onLoad={() => setLoading(false)}/>

            :
            <div className={`${s.mentorCardAvatar} ${s.shimmerBg}`} style={{cursor: 'pointer', zIndex: 0}} onLoad={() => setLoading(false)}/>
        }

        {mentor && loading && <div className={`${s.mentorCardAvatarPlaceholder} ${s.shimmerBg}`} style={{zIndex: 0}}/>}
      </div>

      {mentor ?
          <>
            <Card.Text style={{fontSize: '15px'}} className={'mt-2 mb-1'}>{mentor.firstName} {' '}
              {mentor.profileComplete ? <>
                <img style={{width: '10%', verticalAlign: 'text-bottomsss'}} data-tip data-for="verificationTip"
                     src={verifiedLogo} alt="Verified"/>
                <ReactTooltip id="verificationTip" place="top" effect="solid">
                  This user has completed their NXSTEP profile. Their compatibilty ranking is more accurate.
                </ReactTooltip>
              </> : <></>}</Card.Text>
          </> :
          <>
            <div className={`${s.textPlaceHolder} ${s.shimmerBg}`}></div>
          </>
      }

      {mentor ?
          <>
          {mentor.collegeName &&
              <Card.Text style={{fontSize: '13px'}} className='trunc mb-2'>
                <IoMdSchool color='#7678ed'/> {' '}{mentor.collegeName || '-'}
              </Card.Text>
          }
          </> :
          <>
            <div className={`${s.textPlaceHolder} ${s.shimmerBg} mb-2`}></div>
          </>
      }

      {mentor ?
          <>
            <Tile width={'100%'} fontSize={'0.8em'} color={'green'}>{majors[mentor.major] || 'Unknown'}</Tile>
          </> :
          <>
            <div className={`${s.majorPlaceholder} ${s.shimmerBg} mb-2`} style={{background: '#23CDAA'}}></div>
          </>
      }

      <div>
        {props.children}
      </div>

      {connection ? <>
        <div style={{justifyContent: 'center'}}>
          <div style={{marginTop: '30px', cursor: 'pointer'}}>
            <Tile onClick={() => props.respondToConnection('ACCEPTED', connection)} marginBottom={'20px'} width={'100%'}
                  fontSize={'0.8em'} color={'purple'}>Accept</Tile>
          </div>
          <div style={{marginTop: '5px', cursor: 'pointer'}}>
            <Tile onClick={() => props.respondToConnection('REJECTED', connection)} width={'100%'} fontSize={'0.8em'}
                  color={'red'}>Reject</Tile>
          </div>
        </div>
      </> : <></>}
    </Card.Body>
  </Card>
};
